var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-container", [
    _c("main", [
      _c("h1", [_vm._v("Summary")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "Thank you for your order, you will receive confirmation via email or text shortly. Your order reference is "
        ),
        _c("strong", [_vm._v(_vm._s(_vm.order.booking_id))]),
        _vm._v(".")
      ])
    ]),
    _vm._v(" "),
    _c("aside", [_c("cart", { attrs: { editable: false } })], 1)
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }